import { AnimalOverview } from "../components/AnimalOverview";

/**
 * "Dieren geplaatst" route wrapper — the placed-animals overview (Jmix `DierPlacementOverview`
 * migration). Source parity: the source is the SAME `dier-aanwezig` screen loaded with `?bron=vertrokken`
 * (`VertrokkenOverzichtService` returns the identical payload shape, with `status` = "Vertrokken op …").
 * So this reuses the shared {@link AnimalOverview} pointed at the placed feed (`/api/animals/placed`,
 * which now returns the attendance envelope) instead of a bespoke grid — same stat cards, filters, field
 * chooser, view modes and sort as "Dier aanwezig".
 */
export function AnimalPlacedView({ onOpenAnimal }: { onOpenAnimal: (id: string) => void }) {
  return (
    <AnimalOverview
      endpoint="animals/placed"
      onOpenAnimal={onOpenAnimal}
      showStatCards
      showFosterToggle
      prefsKey="dierGeplaatst"
      titleKey="dierGeplaatst.title"
      subtitleKey="dierGeplaatst.subtitle"
      showDepartureFilters
    />
  );
}
